import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EntityModel } from '@data-layer/models/entities';
import { enumEntityByKey, enumEntityModelCode } from '@data-layer/enums/entities';
import { InvoiceModel, LineModel } from '@data-layer/models/entry-summaries';

@Component({
  selector: 'desktop-isf-summary-hts',
  template: `
    <desktop-isf-summary-card [header]="'LABELS.INTERNATIONAL_HTS_CODE' | translate" [isColumn]="true">
      <ng-container body>
        <desktop-isf-summary-hts-body
          *ngFor="let manufacturer of manufacturers; let i = index"
          [manufacturer]="manufacturer"
          [rowNumber]="i + 1"
          [isShowRowNumber]="manufacturers.length > 1"
          [lineItems]="htsByInvoice(manufacturer?.invoiceId)"
          [isFirstRow]="i === 0"
          [isLastRow]="i === manufacturers.length - 1"
          [isEditMode]="isEditMode"
          (edit)="edit.emit($event)"
          (editHTS)="editHTS.emit($event)"
          (deleteHTS)="deleteHTS.emit({ id: $event, invoiceId: manufacturer?.invoiceId })"
          (deleteMF)="deleteMF.emit($event)"
        ></desktop-isf-summary-hts-body>

        <div class="validation-errors" *ngIf="manufacturers?.length === 0">
          <span class="text-error">{{ 'BACK_ERROR.INVOICES_MISSING' | translate }}</span>
        </div>
      </ng-container>

      <ng-container footer>
        <div class="desktop-isf-summary-hts-footer">
          <button type="button" class="btn btn-link" (click)="addMF.emit()">
            <i class="fa fa-plus-circle"></i>
            <span>{{ 'INFO.MF.ADD_NEW_DESKTOP' | translate }}</span>
          </button>
        </div>
      </ng-container>
    </desktop-isf-summary-card>
  `,
  styleUrls: ['./desktop-summary-hts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopSummaryHtsComponent {
  @Input() public manufacturers: EntityModel[];
  @Input() public invoices: InvoiceModel[];
  @Input() public isEditMode: boolean;
  @Output() public edit: EventEmitter<{ id: number; entityType: enumEntityModelCode }> = new EventEmitter<{
    id: number;
    entityType: enumEntityModelCode;
  }>();
  @Output() public editHTS: EventEmitter<{ manufacturerId: number; invoiceId: number }> = new EventEmitter<{
    manufacturerId: number;
    invoiceId: number;
  }>();
  @Output() public deleteHTS: EventEmitter<{ id: number; manufacturerId: number; invoiceId: number }> = new EventEmitter<{
    id: number;
    manufacturerId: number;
    invoiceId: number;
  }>();
  @Output() public deleteMF: EventEmitter<{ manufacturerId: number; invoiceId: number }> = new EventEmitter<{
    manufacturerId: number;
    invoiceId: number;
  }>();
  @Output() public addMF: EventEmitter<void> = new EventEmitter<void>();

  public enumEntityModelCode: typeof enumEntityModelCode = enumEntityModelCode;
  public enumEntityByKey: typeof enumEntityByKey = enumEntityByKey;

  constructor() {}

  public htsByInvoice(invoiceId: number): LineModel[] {
    return [].concat(...this.invoices.filter((item: InvoiceModel) => item.id === invoiceId).map((item: InvoiceModel) => item.lines));
  }
}
